// Fetch environment name
const ENV_NAME = import.meta.env.MODE;
console.log(ENV_NAME); 
const CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID;
const ISSUER = import.meta.env?.VITE_OKTA_ISSUER;
const VITE_OKTA_TESTING_DISABLEHTTPSCHECK = import.meta.env.VITE_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const BASENAME = import.meta.env.VITE_BASE_URL;
const REDIRECT_URI = `${window.location.origin}/login/callback`;
// BASE URL
const ORIGIN_BASE_URL = window.location.origin;

const VITE_K12_CHAT_URL = import.meta.env.VITE_K12_CHAT_URL;
console.log(VITE_K12_CHAT_URL);

// Environment-wise logout redirect URIs
// const LOGOUT_REDIRECT_URIS: Record<string, string> = {
//     prod: "https://login-learn.k12.com/",
//     dev: "https://cdevtc31-mps.k12.com/",
//     qa: "https://test1-mps.k12.com/",
//     perf: "https://internal-gh-mps-aws.perf.k12.com/",
// };
const POST_LOGOUT_REDIRECT_URI = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI;
// console.log("Logout Redirect URI:", POST_LOGOUT_REDIRECT_URI);

// Application routes
const ROUTES = {
    HOME: ORIGIN_BASE_URL,
    MAIN_CHECKLIST_DOMAIN: `${ORIGIN_BASE_URL}/k12-checklist`,
    FORM_DOCS_MAIN_CHECKLIST: `${ORIGIN_BASE_URL}/k12-checklist`,

    SCHOOL_PREP_CHECKLIST: `${ORIGIN_BASE_URL}/school-prep-checklist`,
    CONTACT: `${ORIGIN_BASE_URL}/contact`,
    COMMUNITY: `${ORIGIN_BASE_URL}/community`,
    LC_COMMUNITY: `${ORIGIN_BASE_URL}/community/learning-coach-community`,
    K12ZONE: `${ORIGIN_BASE_URL}/community/k12-zone`,

    EMAIL_SETUP: `${ORIGIN_BASE_URL}/k12-checklist-category/email-setup/`,
    EMAIL_BASICS: `${ORIGIN_BASE_URL}/k12-checklist/email-basics/`,
    EMAIL_OPTIONS: `${ORIGIN_BASE_URL}/k12-checklist/email-options/`,

    FORM_DOCS_VIEW_ALL: `${ORIGIN_BASE_URL}/k12-checklist-category/forms-and-documents/`,
    SCHOOL_DOCS: `${ORIGIN_BASE_URL}/k12-checklist/school-documents/`,
    CONSENT_PROCESS: `${ORIGIN_BASE_URL}/k12-checklist/consent-process/`,

    LEARNING_COACH_OVERVIEW_URL: `${ORIGIN_BASE_URL}/k12-checklist/what-is-a-learning-coach/`,
    LEARNING_COACH_ROLE_URL: `${ORIGIN_BASE_URL}/k12-checklist/what-does-a-learning-coach-do/`,

    ONLINE_SCHOOL: `${ORIGIN_BASE_URL}/k12-checklist-category/online-school/`,
    SCHOOL_START_FAQ: `${ORIGIN_BASE_URL}/k12-checklist/school-start-faqs/`,
    NAVIGATE_OS: `${ORIGIN_BASE_URL}/k12-checklist/navigating-the-online-school/`,
    SAMPLE_LESSONS: `${ORIGIN_BASE_URL}/k12-checklist/sample-lessons/`,
};
// BACKEND API URLs
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_ENDPOINTS = {
    USER_DATA: `${API_BASE_URL}/lrnx/user`,
    CHECKLIST_DATA: `${API_BASE_URL}/checklist`, 
    CHECKLIST_TOPIC_STATUS: `${API_BASE_URL}/checklist/all`,
    CHECKLIST_TOPIC_STATUS_BY_ID: (id: number) => `${API_BASE_URL}/checklist/${id}`,
    TOOL_SETTINGS_STATUS: `${API_BASE_URL}/toolsettings`,
    QUICKLINKS: `${API_BASE_URL}/quicklinks`,
    ENROLLMENTPORTAL_USER_CREATION_STATUS: `${API_BASE_URL}/account/verifyemail`,
};
// External Links 
const LINKS = {
    CONSENT_URL: import.meta.env.VITE_CONSENT_URL,
    COMMUNITY_URL: import.meta.env.VITE_COMMUNITY_URL,
    ENROLLMENT_PORTAL: import.meta.env.VITE_ENROLLMENT_PORTAL_URL,
    APPLYNOW_PORTAL: import.meta.env.VITE_SALESFORCE_PORTAL_URL,
    K12Zone_URL: import.meta.env.VITE_K12ZONE_URL,
};
// Private School IDs 5766 dev env Validation
const PRIVATE_SCHOOL_IDS = [
    "23266", "15006", "4782", "21067", "2680",
    "7135", "2700", "3227", "23566", "19766"
];
// Export Configuration
export default {
    ENV_NAME,
    LINKS,
    CHAT_URL: VITE_K12_CHAT_URL,
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: REDIRECT_URI,
        postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
        scopes: ["openid", "profile", "email"],
        pkce: true,
        disableHttpsCheck: VITE_OKTA_TESTING_DISABLEHTTPSCHECK,
    },
    app: {
        baseUrl: ORIGIN_BASE_URL,
        routes: ROUTES,
        privateSchoolIds: PRIVATE_SCHOOL_IDS
    },
    api: {
        baseUrl: API_BASE_URL,
        endpoints: API_ENDPOINTS,
    },
};
